<template>
  <div class="h-dialog2">
    <div class="h-dialogImg">
      <div class="h-disTable">
        <div class="h-tableCell">
          <h1>{{titleName}}</h1>
        </div>
      </div>
    </div>
    <div class="h-formLines">
      <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
        <el-form-item label="单位名称" class="h-elformWrap-2" style="width: 50%" label-width="100" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
          <el-select v-model="add.deptName"  remote :filterable="true" :filter-method="selectDept" clearable placeholder="请输入" allow-create filterable
                     :remote-method="selectDept" @change="changeDeptName($event)" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
            <el-option v-for="(item,index) in deptNameList"
                       :key="index"
                       :label="item.deptName"
                       :value="item.deptName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="渠道" class="h-elformWrap-2" style="width: 50%" label-width="100" prop="deptSourceChannel2" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
          <brselectlazy category="channel_classification" :v="add.deptSourceChannel2" :showcode="true" @change="changeChannel($event)"
                        v-model="add.deptSourceChannel2" :clearable="true"/>
        </el-form-item>
        <el-form-item  label="用户分类" class="h-elformWrap-2" style="width: 50%" label-width="100" prop="schoolTypeName2" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
          <el-select v-model="add.schoolTypeName2" :v="add.schoolTypeName2" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]"
                     @change="changeSchoolType($event)"  placeholder="请选择" clearable>
            <el-option v-for="item in addressTypeList"
                       :key="item.id"
                       :label="item.userUnit"
                       :value="item.userUnit">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地标性" class="h-elformWrap-2" style="width: 50%" prop="landmark" label-width="100"
                      :rules="[{ required: true, message: '请选择地标性', trigger: 'change'},]">
          <el-select v-model="add.landmark" @change="clickGetSeal($event)" placeholder="请选择" clearable>
            <el-option label="KA" value="KA"></el-option>
            <el-option label="省级" value="省级"></el-option>
            <el-option label="地市级" value="地市级"></el-option>
            <el-option label="区县级及以下" value="区县级及以下"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省" class="h-elformWrap-2"  style="width: 33.333%" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
          <el-select v-model="add.province" @change="handleItemChange1" placeholder="省" >
            <el-option
                v-for="item in shenglist"
                :key="item.value"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" class="h-elformWrap-2" style="width: 33.333%" prop="city"
                      :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
          <el-select v-model="add.city" @change="handleItemChange2"
                     :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                     placeholder="市" >
            <el-option
                v-for="item in arealist2"
                :key="item.value"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区" class="h-elformWrap-2" style="width: 33.333%" prop="area"
                      :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
          <el-select v-model="add.area"
                     :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                     placeholder="区" @change="handleItemChange3">
            <el-option
                v-for="item in arealist3"
                :key="item.value"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="deptName">
          <treeselect
              :options="options"
              :flat="true"
              :default-expand-level="1"
              placeholder="请选择"
              v-model="stVal"
              :multiple="false"
          />
          <treeselect-value :value="stVal" />
        </el-form-item>
        <el-form-item label="详细地址" class="h-elformWrap-1"
                      :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                      prop="address">
          <el-input v-model="add.address" style="width: 100%;"></el-input>
        </el-form-item>
        <div v-if="nameLog" style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem;margin-left: 30px">*
          单位名称曾用名请用英文逗号形式隔开!
        </div>
        <el-form-item v-if="nameLog"  label="单位名称曾用名" class="h-elformWrap-1">
          <el-input type="textarea" style="border: #dedede 1px solid;
                                            width: 100%;" v-model="add.deptNameLog" ></el-input>
        </el-form-item>
      </el-form>
      <div style="display:flex;justify-content:center;margin-bottom:20px">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="send">取消</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ss from '@/api/SystemService'

export default {
  components: {Treeselect},
  props:{
    titleName:'',
    add1:{
      type: Object,
      required: true
    },
    stVal:null,
    updateId:null,
    nameLog:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      add:{
        id: '',
        deptName: '',
        creditCode:'',
        deptType: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark:'',//地标性字段:KA,省级,地市级,区县级及以下
        area: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        address: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude:'',
        latitude:'',
        parentCode:'',
        taskId:'',
        schoolTypeName:'',
        deptNameLog:'',
        //渠道版本2.0
        deptSourceChannel2:'',
        //用户分类版本2.0
        schoolType2:'',
        schoolTypeName2:'',
      },
      addressTypeList:[],
      shenglist: [],
      arealist2:[],
      arealist3: [],
      deptNameList:[],
      address:{
        name: '',
        provinceCenter:'',
      },
      options:[],
      proSelect: {
        pcode: 0,
        level: 1,
      },
    };
  },
  created() {
    this.getParentInfo();
    this.loadArea();
  },
  watch: {
    'updateId': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        console.log('子组件:',newValue)
        if (null != newValue && '' != newValue){
          ss.nxAddress.selectById(newValue).then(rd => {
            if (null == rd.msg.schoolTypeName || '' == rd.msg.schoolTypeName){
              rd.msg.schoolTypeName = '';
            }
            if (null == rd.msg.schoolTypeName2 || '' == rd.msg.schoolTypeName2){
              rd.msg.schoolTypeName2 = '';
            }
            if (null == rd.msg.deptSourceChannel2 || '' == rd.msg.deptSourceChannel2){
              rd.msg.deptSourceChannel2 = '';
            }
            if (null == rd.msg.deptNameLog || '' == rd.msg.deptNameLog){
              rd.msg.deptNameLog = '';
            }
            this.add = rd.msg;
            var parentCode = new Array();
            parentCode.push(this.add.parentCode);
            this.stVal = this.add.parentCode;
          })
        }
      },
    },
  },
  methods: {
    loadArea(i) {
      ss.Dictservice.arealist(this.proSelect).then(rd => {
        this.shenglist = rd;
        console.log("shenglist",this.shenglist)
      })
    },
//获取单位名称信息
    selectDept(value){
      ss.nxAddress.getDeptList(value).then(rd =>{
        this.deptNameList = rd.msg;
      })
    },
    changeDeptName(val){
      console.log("changeDeptName",val)
      //调用接口，匹配省市区信息
      ss.nxAddress.getAddressByWl(val).then(rd=>{
        if(rd.f == true){
          this.add.provinceId = rd.msg.provinceId;
          this.add.creditCode = rd.msg.creditCode;
          this.add.province = rd.msg.province;
          this.add.cityId = rd.msg.cityId;
          this.add.city = rd.msg.city;
          this.add.areaId = rd.msg.areaId;
          this.add.area = rd.msg.area;
          this.add.landmark = rd.msg.landmark;
          this.add.address = rd.msg.address;
          this.handleItemChangeN(this.add.provinceId);
        }
      })
      //根据单位名称获取关键字
      ss.nxAddressKeywords.matchKeywords2(val).then(rd=>{
        if(rd.msg != null){
          this.add.deptSourceChannel = rd.msg.channelCode;
          this.add.schoolTypeName = rd.msg.userUnit;
          this.add.deptSourceChannel2 = rd.msg.deptSourceChannel2;
          this.add.schoolTypeName2 = rd.msg.schoolTypeName2;
          this.matchChannel(rd.msg.deptSourceChannel2)
        }
      })
    },
    //地址选择器-新
    handleItemChangeN(o){
      this.address = _.find(this.shenglist,{code:this.add.provinceId});
      ss.Dictservice.areaTreelist({code:o}).then(rd => {
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
        this.address = _.find(this.arealist2,{code:this.add.cityId});
        this.arealist3 = _.find(this.arealist2,{code:this.add.cityId}).zlist
      })
    },
    matchChannel(value){
      console.log("value",value)
      ss.nxAddress.getAddressTypeByChannel2(value).then(rd =>{
        this.addressTypeList = rd.msg;
        // this.add.schoolTypeName = '';
      })
    },
    clickGetSeal(value){
      this.add.landmark = value
    },
    //渠道改变
    changeChannel(value){
      console.log("value",value)
      ss.nxAddress.getAddressTypeByChannel2(value.code).then(rd =>{
        this.addressTypeList = rd.msg;
        this.add.schoolTypeName2 = '';
      })
    },
    changeSchoolType(value){
      console.log(value)
      this.add.schoolTypeName2 = value;
    },
    //省份选择器
    handleItemChange1(o){
      this.add.provinceId = o;
      this.address = _.find(this.shenglist,{code:this.add.provinceId});
      this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({code:o}).then(rd => {
        console.log("rddddddd",rd.zlist)
        this.add.city = '';
        this.add.area = '';
        this.add.landmark = '';
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
      })
    },
    handleItemChange2(o){
      this.add.cityId = o;
      this.address = _.find(this.arealist2,{code:this.add.cityId});
      this.add.city = this.address.name;
      if ('1' == this.address.provinceCenter){
        this.add.landmark = '省级'
      }else if (null != this.add.deptName && (this.add.deptName.indexOf('市') != -1 && this.add.deptName.indexOf('区') == -1)){
        this.add.landmark = '地市级'
      }else {
        this.add.landmark = '区县级及以下'
      }
      this.add.area = '';
      this.arealist3 = _.find(this.arealist2,{code:o}).zlist
      console.log("arealist3",this.arealist3)
    },
    handleItemChange3(o){
      this.add.areaId = o;
      this.address = _.find(this.arealist3,{code:this.add.areaId});
      this.add.area = this.address.name;
      if ('KA' != this.add.landmark && '省级' != this.add.landmark){
        if (null != this.add.deptName && ((this.add.deptName.indexOf('市') != -1 && this.add.deptName.indexOf('区') == -1) || '市辖区' == this.add.area)){
          this.add.landmark = '地市级'
        }else {
          this.add.landmark = '区县级及以下'
        }
      }
    },
    //获取当前登录人创建的所有父级单位
    getParentInfo(v){
      ss.nxAddress.getParentInfo().then(rd =>{
        this.options = rd.msg;
      })
    },
    send(){
      this.updateId = null;
      this.add.id = '';
      this.add.deptName = '';
      this.add.deptType = '';
      this.add.status = '';
      this.add.countryId = '';
      this.add.country = '';
      this.add.provinceId = '';
      this.add.province = '';
      this.add.cityId = '';
      this.add.city = '';
      this.add.areaId = '';
      this.add.landmark = '';//地标性字段:KA,省级,地市级,区县级及以下
      this.add.area = '';
      this.add.shengobj = '';
      this.add.shiobj = '';
      this.add.quobj = '';
      this.add.selectId =  '';
      this.add.address = '';
      this.add.subFlag = '';
      this.add.deptSourceChannel = '';
      this.add.longitude = '';
      this.add.latitude = '';
      this.add.parentCode = '';
      this.add.taskId = '';
      this.add.schoolTypeName = '';
      this.add.deptNameLog = '';
      //渠道版本2.0
      this.add.deptSourceChannel2 = '';
      //用户分类版本2.0
      this.add.schoolType2 = '';
      this.add.schoolTypeName2 = '';
      this.$emit('getChildValue',1)
    },
    commitCreate(){
      if ('新建用户单位' == this.titleName || '新建收货单位' == this.titleName){//新增
        this.add.subFlag = '提交';
      }else if ('修改用户单位' == this.titleName){//修改
        this.add.subFlag = '修改';
      }else if ('新增用户单位' == this.titleName){//驳回重新提交
        this.add.subFlag = '重新提交';
      }
      this.add.countryId = '156';
      this.add.country = '中国';
      this.add.provinceId = this.add.provinceId.substring(0,6);
      this.add.cityId = this.add.cityId.substring(0,6);
      this.add.areaId = this.add.areaId.substring(0,6);
      this.add.parentCode = this.stVal;
      var data = this.add;
      console.log("address",data)
      if ('新建用户单位' == this.titleName || '新增用户单位' == this.titleName || '新建收货单位' == this.titleName){
        ss.nxAddress.insertAddress(data).then(rd => {
          this.$emit('getChildValue',2)
        })
      }else if ('修改用户单位' == this.titleName) {
        ss.nxAddress.updateAddress(data).then(rd => {
          this.$emit('getChildValue',2)
        })
      }
    },
  }
}
</script>

<style scoped>
/* 兼容 */
::v-deep .h-formbLine .el-form-item__label {
  width: 140px;
}

::v-deep .h-formbLine .el-form-item__content {
  width: 150px;
}

.addPro .el-form-item {
  width: 45% !important;
}

.addPro .el-form-item ::v-deep .el-form-item__content {
  width: 115px;
}

::v-deep.h-dialog2 .h-formbLine .el-form-item__label{
  width: 140px!important;
}
::v-deep.h-dialog2 .h-formbLine .el-form-item__content{
  width: 150px!important;
}
</style>